document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(".easify-product-options");
  const insertAfterElement = document.querySelector("#teeFormInputs");
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const updateAllPreviewButtons = () => {
    document.querySelectorAll(".tee-preview-button__text").forEach((btn) => {
      if (btn.textContent !== "Design Vorschau") {
        btn.textContent = "Design Vorschau";
      }
    });
  };

  updateAllPreviewButtons();

  const observer = new MutationObserver(updateAllPreviewButtons);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
